import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, GridColumn, GridToolbar, } from "@progress/kendo-react-grid";
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Button } from "@progress/kendo-react-buttons";
import {
  createDocument,
  deleteDocument,
  updateDocument,
} from '../../actions/index.js'
import Dialog from '../../components/Dialog/Dialog';
import EditDocumentForm from '../../components/EditDocumentForm.jsx';
import { process } from '@progress/kendo-data-query';
import { CheckmarkCell, DateCell, EditCommandCell, GroupCell } from '../../components/GridCell'
import { formCloser } from '../../utils/formCloser.js';
import { clearMessage, setMessage } from '../../store/actions/dialogActions.js';
import { updateLayer } from '../../actions/portal/layer/updateLayer.js';
import { createLayer } from '../../actions/portal/layer/createLayer.js';
import EditLayerForm from '../../components/EditLayerForm.jsx';
import { deleteLayer } from '../../actions/portal/layer/deleteLayer.js';
import { esriFields as esriFieldsGetter } from '../../actions/portal/esri/esriFields.js';

const initialDataState = {
  skip: 0,
  take: 10,
  // sort: [
  //   { field: 'lastName', dir: 'asc' }
  // ],
}

const DashboardLayers = () => {
  const _export = React.useRef(null);

  const { token, user } = useSelector(state => state.authReducer);
  const { esriFields } = useSelector(state => state.esriReducer)
  const { layers } = useSelector(state => state.layerReducer);
  const { groups } = useSelector(state => state.groupsReducer);

  const [openForm, setOpenForm] = useState(false);
  const [dataState, setDataState] = useState(initialDataState);
  const [dialogProps, setDialogProps] = useState({});
  const [selectedLayer, setSelectedLayer] = useState({});
  const [showDialog, setShowDialog] = useState(false);

  const parsedLayers = layers.map(u => {
    let copy = { ...u };
    copy.stringGroups = u.Groups.map(g => g.name).join(', ');
    return copy;
  });

  useEffect(() => {
    console.log(esriFields)
  }, [esriFields])

  const dispatch = useDispatch();

  const enterEdit = (item) => {
    const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
    const regex = new RegExp(expression);

    if (item && item.id) {
      dispatch(esriFieldsGetter(item.id, token));
    }
    setOpenForm(true);
    setSelectedLayer(item);
  }

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const deleteEntry = (dataItem) => {
    // prompt for confirmation
    setDialogProps({
      title: `Delete Document`,
      text: `Are you sure you want to delete this record?`,
      onConfirm: () => {
        dispatch(deleteLayer(dataItem.id, token, formCloser(setShowDialog)))
      },
      enableCancelBtn: true
    });

    setShowDialog(true);
  }


  const editFormSubmit = (event) => {
    dispatch(setMessage({ type: 'LOAD' }))
    if (event.id) {
      dispatch(updateLayer(event.id, { ...event, siteId: user.site.id }, token, formCloser(setOpenForm), user))
    } else {
      dispatch(createLayer({ ...event, siteId: user.site.id }, token, formCloser(setOpenForm)));
    }
  }

  return (
    <div>
      <ExcelExport ref={_export} data={parsedLayers}>
        <Grid
          {...dataState}
          data={process(parsedLayers, dataState)}
          onDataStateChange={e => setDataState(e.dataState)}
          pageable={true}
          sortable={true}
          className='flo-document-grid'
        >
          <GridToolbar>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                {(!user.viewOnly && !user.notificationOnly) ? <Button
                  className="k-button k-primary"
                  style={{
                    minHeight: 25,
                    padding: '10px 20px',
                    marginLeft: 15,
                  }}
                  onClick={() => {
                    enterEdit({
                      filename: "",
                      Groups: [],
                      file: null
                    })
                  }}
                  iconClass="k-icon k-i-plus"
                >
                  Create Layer
                </Button> : null}
              </div>
            </div>
          </GridToolbar>
          <GridColumn field="name" title="Layer Name" />
          <GridColumn   
            field="url" 
            title="Layer URL" 
          />
          <GridColumn   
            field="attribute_1" 
            title="Attribute 1" 
          />
          <GridColumn   
            field="attribute_2" 
            title="Attribute 2" 
          />
          <GridColumn   
            field="attribute_3" 
            title="Attribute 3" 
          />
          <GridColumn
            title="Default"
            field="defaultLayer"
            cell={props => <CheckmarkCell checked={props.dataItem.defaultLayer} />}
            width={150}
          />
          <GridColumn
            field="stringGroups"
            title="Groups"
            cell={props => <GroupCell groups={props.dataItem.Groups} />}
          />
          <GridColumn
            title="Created"
            field="createdAt"
            cell={props => <DateCell date={props.dataItem.createdAt} />}
            width={150}
          />
          <GridColumn
            cell={(props) => (
              <EditCommandCell
                {...props}
                user={user}
                enterEdit={enterEdit}
                deleteEntry={(dataItem) => deleteEntry(dataItem)}
              />
            )}
            width={100}
          />
        </Grid>
      </ExcelExport>
      {openForm && (
        <EditLayerForm
          groups={groups}
          fields={esriFields}
          cancelEdit={handleCancelEdit}
          onSubmit={editFormSubmit}
          item={selectedLayer}
        />
        )}
      {showDialog &&
        <Dialog
          {...dialogProps}
          onClose={() => setShowDialog(false)}
        />}
    </div>
  )
}

export default DashboardLayers;